export default __webpack_public_path__ + "static/media/number-one.a6264069.svg";